"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "carpaneto-piacentino": {
    "03af99c6": [{
      "hkey": "c8cdf4b3",
      "slug": "magnano",
      "name": "Magnano",
      "primary": true,
      "skipSearch": false
    }],
    "magnano-montanaro": [{
      "hkey": "c8cdf4b3",
      "slug": "magnano",
      "name": "Magnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "63b0b3e1": [{
      "hkey": "bb489488",
      "slug": "carpaneto-piacentino",
      "name": "Carpaneto Piacentino",
      "primary": true,
      "skipSearch": false
    }],
    "travazzano": [{
      "hkey": "bb489488",
      "slug": "carpaneto-piacentino",
      "name": "Carpaneto Piacentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;